namespace TabAurous.ECommerce {
    export namespace ECommOrderAddressService {
        export const baseUrl = 'ECommerce/ECommOrderAddress';

        export declare function Create(request: Serenity.SaveRequest<ECommOrderAddressRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ECommOrderAddressRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommOrderAddressRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ECommOrderAddressRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommerce/ECommOrderAddress/Create",
            Update = "ECommerce/ECommOrderAddress/Update",
            Delete = "ECommerce/ECommOrderAddress/Delete",
            Retrieve = "ECommerce/ECommOrderAddress/Retrieve",
            List = "ECommerce/ECommOrderAddress/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ECommOrderAddressService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
